// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"74e6e73f","434":"a3b6368d","660":"03c3e641"}[chunkId] + ".chunk.css";
};